import { render, staticRenderFns } from "./_denied.vue?vue&type=template&id=666a459d&lang=pug"
import script from "./_denied.vue?vue&type=script&lang=js"
export * from "./_denied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports